





































































import { Component, Vue } from 'vue-property-decorator';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import { TableStripe } from '@/mixins/tableStripe';
import PagingUnit from '@/components/paging/paging.vue';
import { doublePrevention, institutionServer, patrolManagementServe } from '@/api/installServer';
import Add from '@/views/enterpriseEmergencyPlan/unit/publicPage.vue';
import { arrayToTree } from '@/util/arrayToTree';

@Component({
  components: { CollapseTransition, PagingUnit, Add },
  mixins: [TableStripe],
})
export default class EnterpriseEmergencyPlan extends Vue {
  private showFlag = 0;
  row: any = {};

  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  total = 1000; // 数据总共多少条

  treeData: Array<any> = []; // 树状图数据
  openAsideFlag = false; // 侧边栏是否打开

  // 搜索表单数据
  formData: any = {
    name: '', // 巡检线路名称
  };
  // formShow = false; // 是否显示表单搜索
  // table数据
  tableData: any[] = [];
  // 执行部门
  subSpaceByAuthOptions: any = [];
  private loading = false;
  /**
   * @desc 获取部门所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getSubSpaceByAuth() {
    const userInfo: any = JSON.parse((localStorage as any).getItem('userInfo'));
    // 发起接口请求，获取分页数据
    institutionServer
      .getDeptAndSubDeptList({
        deptId: userInfo.deptId,
      })
      .then((res: any) => {
        this.subSpaceByAuthOptions = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  created() {
    this.getSubSpaceByAuth();
    this.getPlanList();
  }

  private getPlanList(): void {
    this.loading = true;
    doublePrevention
      .getEnterpriseEmergencyPlanList({
        pageNo: (this.queryDataForm as any).pageNo,
        pageSize: (this.queryDataForm as any).pageSize,
      })
      .then((res: any) => {
        this.loading = false;
        if (res.code === '200') {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc  分页发生改变触发，获取到新的 table 数据。
   */
  getListData() {
    this.getPlanList();
  }
  /**
   * @desc 点击查询按钮触发，查询符合条件的内容
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    (this.queryDataForm as any).pageNo = 1;
    this.getPlanList();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击重置按钮触发，重置表单内容
   * @param1 暂无
   * @returns 暂无
   */
  resetForm() {
    (this.$refs.formRef as any).resetFields();
    (this.queryDataForm as any).pageNo = 1;
    // 获取全部数据
    this.getPlanList();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击隐藏和显示按钮触发，控制表单搜索内容是否显示
   * @param1 暂无
   * @returns 暂无
   */
  // setFormShow() {
  //   this.formShow = !this.formShow;
  // }

  editHandle(data: any) {
    this.row = {
      type: 'edit',
      id: data.id,
    };
    this.showFlag = 1;
  }
  addHandle() {
    this.row = {
      type: 'add',
    };
    this.showFlag = 1;
  }
  deleteHandle(data: any) {
    this.$confirm('此操作将永久删除该巡检线路, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        doublePrevention.deleteEnterpriseEmergencyPlan(data.id).then((res: any) => {
          if (res.code === '200') {
            this.$message.success('删除成功！');
            this.getPlanList();
          } else {
            this.$message.success(res.msg);
          }
        });
      })
      .catch(() => {});
  }

  responseHandle() {
    this.showFlag = 0;
    this.getPlanList();
  }
}
